/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewsletterSchemasOut
 */
export interface NewsletterSchemasOut {
    /**
     * 
     * @type {number}
     * @memberof NewsletterSchemasOut
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSchemasOut
     */
    name: string;
}

export function NewsletterSchemasOutFromJSON(json: any): NewsletterSchemasOut {
    return NewsletterSchemasOutFromJSONTyped(json, false);
}

export function NewsletterSchemasOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsletterSchemasOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function NewsletterSchemasOutToJSON(value?: NewsletterSchemasOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


